import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContext, useRef } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider, ThemeContext } from 'styled-components';
import { deepMerge } from '@chegg-ui/utils';
import { fanta, horizon } from './themes';
import { CUI_Theme } from './shared';
export * from './types';
export var themes = {
  fanta: fanta,
  horizon: horizon
};
export var defaultTheme = horizon;
export var ThemeProvider = StyledComponentsThemeProvider;
/**
 * Create CUI theme
 * @param customTheme
 * @param theme
 * @param appTheme
 * @returns
 */

export var createTheme = function createTheme() {
  var customTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var theme = arguments.length > 1 ? arguments[1] : undefined;
  var appTheme = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _objectSpread({
    cuiTheme: deepMerge(theme || defaultTheme, customTheme)
  }, appTheme);
};
/**
 * IIFE to store generated components theme for specific theme type
 */

var generatedComponentTheme = function () {
  var theme = {};
  return {
    get: function get(themeName, compName) {
      var _theme$themeName;

      return (_theme$themeName = theme[themeName]) === null || _theme$themeName === void 0 ? void 0 : _theme$themeName[compName];
    },
    set: function set(themeName, compName, compTheme) {
      if (theme[themeName]) {
        theme[themeName][compName] = compTheme;
      } else {
        theme[themeName] = _defineProperty({}, compName, compTheme);
      }
    }
  };
}();

var getTheme = function getTheme(compTheme, rootTheme) {
  return typeof compTheme === 'function' ? compTheme(rootTheme) : compTheme;
};
/**
 * Hook to create component theme
 * @param options
 * @returns
 */


export var useComponentTheme = function useComponentTheme(options) {
  var themeContext = useContext(ThemeContext);
  var rootTheme = defaultTheme;

  if (themeContext && CUI_Theme in themeContext) {
    rootTheme = themeContext[CUI_Theme];
  }

  var rootThemeRef = useRef(rootTheme);
  var inlineComponentTheme = getTheme(options.theme.prop, rootTheme);
  var componentTheme = generatedComponentTheme.get(rootTheme.name, options.name);

  if (!componentTheme || rootTheme !== rootThemeRef.current) {
    var _rootTheme$components;

    var rootComponentTheme = getTheme((_rootTheme$components = rootTheme.components) === null || _rootTheme$components === void 0 ? void 0 : _rootTheme$components[options.name], rootTheme);
    var defaultComponentTheme = getTheme(options.theme["default"], rootTheme);
    var customComponentTheme = getTheme(options.theme[rootTheme.name], rootTheme);
    componentTheme = deepMerge(defaultComponentTheme, customComponentTheme);

    if (rootComponentTheme) {
      componentTheme = deepMerge(componentTheme, rootComponentTheme);
    }

    generatedComponentTheme.set(rootTheme.name, options.name, componentTheme);
  }

  if (inlineComponentTheme) {
    componentTheme = deepMerge(componentTheme, inlineComponentTheme);
  }

  return componentTheme;
};